import gql from "graphql-tag";

export const ticketEventsSummaryQuery = gql`
  query TicketEventsForSummary {
    ticket_events {
      id
      status
      external_reference
      code
      colour
      name
      description
      start_date
      end_date
      ticket_sales_close_date
      location
      facebook_page
      instagram_page
      approval_comments
      approval_audit_trail
      active_custom_ticket_types {
        name
      }
      available_tickets
      sold_tickets
      merchant {
        id
        name
        store_infos {
          icon
        }
      }
      ticket_event_series {
        id
        name
      }
      ticket_options {
        id
        price
        multi_use
        ticket_type {
          id
          name
        }
      }
    }
  }
`;
